import { makeStyles } from "@material-ui/core";
import { Save, SvgIconComponent } from "@material-ui/icons";
import React from "react";
import { AppBarButton, AppBarButtonProps } from "./AppBarButton";
import { useUpdatingButtonText } from "./useUpdatingButtonText";

const DEFAULT_LIFECYCLE_LABELS: [string, string, string] = [
  "Save",
  "Saving",
  "Saved",
];

const DEFAULT_SAVING_LABEL_DURATION_MS = 2000;

const DEFAULT_ICON = Save;

type AppBarSaveButtonProps =
  //<T extends ReduxStateShape>
  Omit<AppBarButtonProps, "text" | "tooltip" | "Icon"> & {
    lifecycleLabels?: [string, string, string];
    //state: [T, string];
    isSubmitting: boolean | undefined | null;
    isSubmitted: boolean | undefined | null;
    Icon?: SvgIconComponent;
    dataTest?: string;
  };

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 110, // todo: make this scale to the widest label in the tuple
  },
}));

export const AppBarSaveButton = ({
  lifecycleLabels = DEFAULT_LIFECYCLE_LABELS, // we can override the labels if we want e.g. create, creating, created
  Icon = DEFAULT_ICON,
  isSubmitting,
  isSubmitted,
  dataTest,
  ...props
}: AppBarSaveButtonProps) => {
  const text = useUpdatingButtonText(
    // state[0].status === state[1],
    // !!state[0]?.lastCrudResult.isSuccess,
    isSubmitting,
    isSubmitted,
    lifecycleLabels,
    DEFAULT_SAVING_LABEL_DURATION_MS
  );

  const classes = useStyles();
  return (
    <AppBarButton
      className={classes.root}
      tooltip={lifecycleLabels[0]}
      text={text}
      {...props}
      Icon={Icon}
      data-test={dataTest}
    />
  );
};
